import { tag } from "@simplybusiness/icons";
import { Flex, Icon, Text } from "@simplybusiness/mobius";

type TagProps = {
  text: string;
};

export const Tag = ({ text }: TagProps) => (
  <Flex alignItems="flex-start" className="mobius-quote-card__tag" gap="xxs">
    <Icon icon={tag} size="sm" title="Quote tag" />
    <Text variant="small">{text}</Text>
  </Flex>
);
